import React, { useState } from "react";
import TranslatedKey from "./TranslatedKey";
import Button from "ui-components/Button";

import { FormattedMessage } from "react-intl";

import { TCSSurveyModal } from "./Modals/TCSSurveyModal";

const ConfiguratorSurveyAlertTCS = ({ metadata, title, alertId, saveResponses }) => {
  // metadata
  const { alertText } = metadata;

  // state
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className={`flex w-full justify-between items-center`}>
        <div className="flex flex-col">
          {title ? (
            <div className="mb-1 flex items-center">
              <div>
                <h2 className={`text-xl leading-none`}>
                  <TranslatedKey id={title} />
                </h2>
              </div>
            </div>
          ) : null}
          <div>
            <p className="text-base">{alertText}</p>
          </div>
          <Button className="mt-4" onClick={() => setShowModal(true)} submitting={loading}>
            <FormattedMessage
              id="request_support"
              defaultMessage="Richiedi supporto al TCS"
            />
          </Button>
        </div>
      </div>
      {showModal && (
        <TCSSurveyModal 
        metadata={metadata} 
        saveResponses={saveResponses} 
        alertId={alertId} 
        setShowModal={setShowModal}
        loading={loading}
        setLoading={setLoading}
         />
      )}
    </>
  );
};

export default ConfiguratorSurveyAlertTCS;
